module.exports = __webpack_public_path__ + "static/media/loading.f288f10c.gif";